<template>
  <q-modal v-model="isOpen" @show="openTagsModal()" @hide="close()" :content-css="{width: '520px'}">
    <div class="header q-pa-md">
      Теги
    </div>
    <div class="body">
      <div class="q-px-md">
        <q-chip
          v-for="(tag, index) in getInitialTags()"
          @hide="deleteTag(tag)"
          :key="index"
          closable
          style="margin-right: 2px;"
        >
          {{tag}}
        </q-chip>
      </div>
      <q-field class="tags-search q-px-md">
        <q-chips-input
          v-model="addedTags"
          :before="[{icon: 'search'}]"
          @input="val => { updateFilteredTags(val); }"
          @keyup="filterTags($event.target.value)"
          hide-underline
          square
          ref="chips"
        />
      </q-field>
      <div style="border-top: 1px solid #bbb;">
        <q-inner-loading :visible="!tagsLoaded">
          <q-spinner size="50px" color="primary"></q-spinner>
        </q-inner-loading>
        <ul class="tags-list">
          <li
            v-for="tag in filteredTags"
            :key="tag.id"
            @click="addTag(tag.name)"
            class="q-px-md q-py-sm"
          >{{tag.name}}
          </li>
        </ul>
      </div>

    </div>
    <div class="footer q-pa-md">
      <div class="row justify-end">
        <q-btn
          @click="prepareSave()"
          :disable="saveButtonDisabled"
          color="primary"
          label="Сохранить"
          class="q-mr-sm"
        />
        <q-btn
          @click="close()"
          color="primary"
          flat
          label="Отмена"
        />
      </div>
    </div>

  </q-modal>
</template>

<script>
  import {
    QModal,
    QField,
    QInput,
    QChipsInput,
    QBtn,
    QInnerLoading,
    QSpinner,
    QChip
  } from 'quasar';

  export default {
    name: 'TagsPicker',
    components: {
      QModal,
      QField,
      QInput,
      QChipsInput,
      QBtn,
      QInnerLoading,
      QSpinner,
      QChip
    },
    props: {
      value: Boolean,
      attachedTags: Array
    },
    data () {
      return {
        isOpen: this.value,
        tags: [],
        addedTags: [],
        deletedTags: [],
        filteredTags: [],
        tagsLoaded: false,
        initialTags: []
      };
    },
    watch: {
      value (val) {
        this.isOpen = val;
      },
      attachedTags (val) {
        this.initialTags = [...val];
      }
    },
    computed: {
      saveButtonDisabled () {
        return !(this.addedTags.length || this.deletedTags.length);
      }
    },
    methods: {
      getInitialTags () {
        return this.initialTags;
      },
      openTagsModal (val) {
        this.addedTags = [];
        this.deletedTags = [];
        if (!this.tagsLoaded) {
          this.$http.get(`api/v1.0/tags`).then((response) => {
            this.tags = response.data;
            this.filteredTags = this.tags.filter(val => !this.addedTags.includes(val.name));
            this.tagsLoaded = true;
          });
        } else {
          this.filteredTags = this.tags.filter(val => !this.addedTags.includes(val.name));
        }
      },
      filterTags (val) {
        this.filteredTags = this.tags.filter(
          row => row.name.toLowerCase().includes(val.toLowerCase()) && !this.addedTags.includes(row.name)
        );
      },
      addTag (tag) {
        this.getRef('chips').add(tag);
      },
      deleteTag (tag) {
        this.initialTags.splice(this.initialTags.indexOf(tag), 1);
        this.deletedTags.push(tag);
      },
      updateFilteredTags (tags) {
        this.filteredTags = this.tags.filter(
          val => tags.indexOf(val.name) === -1
        );
      },
      prepareSave () {
        let addedTags = [],
          deletedTags = [],
          newTags = [];

        this.addedTags.forEach(value => {
          let tagObj = this.tags.find(tag => tag.name === value);

          if (tagObj) {
            addedTags.push(tagObj);
          } else {
            newTags.push({
              'name': value
            });
          }
        });

        this.deletedTags.forEach(value => {
          let tagObj = this.tags.find(tag => tag.name === value);

          if (tagObj) {
            deletedTags.push(tagObj);
          }
        });

        if (newTags.length) {
          this.$http.post(`api/v1.0/tags/batch`, newTags).then(response => {
            addedTags = addedTags.concat(response.data);

            this.$emit('save', addedTags, deletedTags);
            this.close();
          }).catch(error => {

          });
        } else {
          this.$emit('save', addedTags, deletedTags);
          this.close();
        }
      },
      close () {
        this.isOpen = false;
        this.initialTags = [...this.attachedTags];
        this.deletedTags = [];
        this.$emit('input', false);
      },
      getRef (key) {
        return this.$refs[key];
      },
      getRefEl (key) {
        return this.$refs[key].$el;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .tags-list {
    height: 300px;
    min-height: 100px;
    overflow: auto;
    padding: 0;
    margin: 0;

    li {
      display: block;
      //padding: 6px 16px;
      font-weight: 500;
      border-top: 1px #fff;
      border-bottom: 1px #fff;
      text-decoration: none;

      &:hover {
        color: #fff;
        background-color: #286efa;
      }

    }
  }

  .header {
    font-size: 26px;
  }

  .footer {
    border-top: 1px solid #bbb;
  }

  .tags-search /deep/ .q-if-control {
    cursor: default;
    pointer-events: none;

    &:hover {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/TagsPicker/TagsPicker.vue